import React from 'react'

import { matchPath, useHistory, useLocation } from 'react-router-dom'

import { useOktaAuth } from '@okta/okta-react'
import { AuthState } from '@okta/okta-auth-js'
import { signOut as cognitoSignOut } from '@api/cognito'
import { signOut as oktaSignOut } from '@api/okta'

import { NavLink } from './styles'

import { segmentTrack } from '@api/segment/track/track'

import { SegmentTrack, SegmentPage } from '@enums/segment'
import { ROUTE } from '@enums/route'
import { NewNavLoginLink } from '@features/NavBar/components/Login'

export const withNavitationLinks = (Component: React.FC<any>) => (props: any) => {
  const history = useHistory()
  const { pathname, search } = useLocation()
  const { authState } = useOktaAuth()

  const ROUTE_VALS: Set<string> = new Set(Object.values(ROUTE))

  const signInLink = (<NavLink key={ROUTE.logIn} to={`${ROUTE.logIn}${search}`} onClick={signInLinkTrack}>Login</NavLink>)
  const signUpLink = (<NavLink key={ROUTE.signUp} to={`${ROUTE.signUp}${search}`} onClick={signUpLinkTrack}>Signup</NavLink>)

  const getLinks = () => {
    let currentRoute: any = { path: null }
    ROUTE_VALS.forEach((route: any) => {
      const e = matchPath(pathname, route)
      if (e?.isExact) {
        currentRoute = e
      }
    })

    if (!currentRoute?.path) {
      return null
    }

    const linksMap = new Map([
      [
        ROUTE.home,
        [
          <NavLink
            key="signOut"
            onClick={() => signOutUser(history.push, authState)}
            to={ROUTE.home}
          >
            Sign out
          </NavLink>,
        ],
      ],
      [ROUTE.signUp, [signInLink]],
      [ROUTE.newHome, [<NewNavLoginLink key={'nav-bar-new-login'} />]],
      [ROUTE.course, [<NewNavLoginLink key={'nav-bar-new-login'} />]],
      [ROUTE.signUpDetails, [signInLink]],
      [ROUTE.logIn, [signUpLink]],
      [ROUTE.password, [signUpLink]],
      [ROUTE.forgotPasswordConfirm, [signInLink]],
      [ROUTE.forgotPassword, [signInLink]],
    ])

    return linksMap.get(currentRoute?.path) as Array<JSX.Element>
  }

  const propsWithLinks = {...props, links: getLinks()}

  return <Component {...propsWithLinks}/>
}


function signInLinkTrack() {
  /* SEGMENT */
  segmentTrack(SegmentTrack.signInBegan, {
    page_name: SegmentPage.logIn,
  })
}

function signUpLinkTrack() {
  /* SEGMENT */
  segmentTrack(SegmentTrack.signUpBegan, {
    page_name: SegmentPage.signUp,
  })
}

async function signOutUser(historyPush: Function, authState: AuthState) {
  const isOktaAuthenticated = authState.isAuthenticated
  if (!isOktaAuthenticated) {
    // doing the additional step of pushing the log-in state, otherwise the user
    // will get redirected to /sign-up if they originally came in through /log-in
    await cognitoSignOut()
    historyPush(ROUTE.logIn)

    return
  }
  await oktaSignOut(authState)
}
